import { createSlice } from '@reduxjs/toolkit';

export const globalSlice = createSlice({
  name: 'global',
  initialState: {
    companiesList: [],
    messages: [],
    totalMessagesCount: 0,
    notifications: [],
    unreadNotifCount: 0,
  },
  reducers: {
    setCompaniesList: (state, action) => {
      state.companiesList = action.payload;
    },
    setMessages: (state, action) => {
      if (action.payload.length > 0) {
        state.messages = [...action.payload, ...state.messages];
      } else {
        state.messages = [];
      }
    },

    setTotalMessagesCount: (state, action) => {
      state.totalMessagesCount = action.payload;
    },
  },
});

export const { setCompaniesList, setMessages, setTotalMessagesCount } = globalSlice.actions;

export default globalSlice.reducer;

export const getCompaniesList = (state) => state?.global?.companiesList;
